// extracted by mini-css-extract-plugin
module.exports = {"header":"e_hn","gallery":"e_in","label":"e_jn"};